import { DataCheck } from '@adaptiva/core/common';
import { canSummonEditorForAction, canSummonUnlessTenant, EJavaClassNames, IServerObject } from '@adaptiva/data-service';
import { of } from 'rxjs';

export const PLATFORM_CAN_SUMMON_CHECKS: Map<string, DataCheck<IServerObject>> = new Map([
	[EJavaClassNames.ActionServerObject, canSummonEditorForAction],
	[EJavaClassNames.AdaptivaPatchContent, () => of(false)],
	[EJavaClassNames.Administrator, canSummonUnlessTenant],
	[EJavaClassNames.OidcCertificateClient, canSummonUnlessTenant],
]);
